import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useDiscoverTheme } from '../../../common/emotion';

export const MenuItemList = styled.div(() => {
  const {
    colors: { SubMenuBackground },
  } = useDiscoverTheme();

  return css`
    padding: 12px;
    background-color: ${SubMenuBackground};
  `;
});

export const MenuItem = styled.div(() => {
  const {
    colors: { DefaultIconColor, LinkButtonTextColor, LinkButtonTextColorHover },
  } = useDiscoverTheme();

  return css`
    a {
      padding: 0.375rem 0.5rem 0.375rem 0.75rem;
      color: ${LinkButtonTextColor};
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 0.75rem;

      &:hover,
      &:focus {
        color: ${LinkButtonTextColorHover};
        text-decoration: none;
      }
    }

    .sicon {
      color: ${DefaultIconColor};
      margin-right: 0.25rem;
    }
  `;
});
